/**
 * Project: xpenser-client
 * FilePath: /src/app/styles/theme/xpenser-theme/index.ts
 * File: index.ts
 * Created Date: Friday, September 18th 2020, 7:11:17 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Sep 18 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 */

import { createMuiTheme } from '@material-ui/core/styles'
import green from '@material-ui/core/colors/green'
import purple from '@material-ui/core/colors/purple'

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: green[500],
    },
    secondary: {
      main: purple[500],
    }
  }
})

export default theme
